import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { dateToString, stringToDate } from "utils/DateUtils";
import DatePicker from "utils/elements/DatePicker";
import { ChangeEvent } from "utils/history/Event";
import { asTitle } from "utils/Utils";

import { DateField } from "core/field/FieldService";
import { FormFieldExpansionProps } from "core/field/form/FormFieldRow";

export type DateFormFieldExpansionProps = FormFieldExpansionProps & {
	field: DateField;
};

const DateFormFieldExpansion: React.FC<DateFormFieldExpansionProps> = (
	props: DateFormFieldExpansionProps
) => {
	const { t } = useTranslation();

	function handleValueChange(date: Date | null) {
		const newValue = dateToString(date);
		const event = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(event);
	}

	return (
		<Grid container direction={"column"} alignItems="flex-start">
			<Grid item container alignItems="center">
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<Typography variant="subtitle2">
						{asTitle(t("default"))}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<DatePicker
						inputProps={{
							variant: "standard",
							fullWidth: true
						}}
						disabled={!props.editable}
						value={stringToDate(props.field.value)}
						onChange={handleValueChange}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default DateFormFieldExpansion;
